/**
 * @fileoverview Botão para salvar versão da DRE
 * @module components/dre/SaveVersionButton
 */

import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

import { useVersionStore } from '../../stores/versionStore';

interface SaveVersionButtonProps {
  /**
   * Callback opcional para executar antes de salvar (ex: forçar auto-save)
   */
  onSave?: () => Promise<void>;
}

export function SaveVersionButton({ onSave }: SaveVersionButtonProps) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const { saveVersion, isSaving } = useVersionStore();

  const handleSave = async () => {
    if (!name.trim()) return;
    
    // Executa callback opcional primeiro (ex: force save do auto-save)
    if (onSave) {
      await onSave();
    }
    
    await saveVersion(name, description);
    setName('');
    setDescription('');
    setOpen(false);
  };

  return (
    <>
      <Button
        startIcon={<SaveIcon />}
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        Salvar Versão
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Salvar Nova Versão</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              autoFocus
              label="Nome da Versão"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex: Ajuste Q4 2024"
              required
            />
            <TextField
              label="Descrição (opcional)"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Descreva as mudanças feitas..."
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={!name.trim() || isSaving}
          >
            {isSaving ? 'Salvando...' : 'Salvar'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
